export const inputStyles = {
  background: 'transparent',
  width: '100%',
  borderRadius: '7.5px',
  paddingLeft: '16px',
  paddingRight: '16px',
  border: 'none !important',
  boxShadow: 'none !important',
};
